import { useEffect, useState } from "react";
import API from "./api";

/** One stable colour per client (assigned server-side). Shared app-wide; refreshed via invalidateClientColours(). */
let cache = null;        // { colours: {id: hex}, palette: [hex] }
let inflight = null;
const listeners = new Set();

const load = () => {
  if (!inflight) {
    inflight = API.get("/clients/colours")
      .then(({ data }) => { cache = { colours: data.colours || {}, palette: data.palette || [] }; listeners.forEach((fn) => fn(cache)); return cache; })
      .catch(() => cache || { colours: {}, palette: [] })
      .finally(() => { inflight = null; });
  }
  return inflight;
};

export const invalidateClientColours = () => { cache = null; return load(); };

export function useClientColours() {
  const [state, setState] = useState(cache || { colours: {}, palette: [] });
  useEffect(() => {
    listeners.add(setState);
    if (!cache) load(); else setState(cache);
    return () => listeners.delete(setState);
  }, []);
  return { colours: state.colours, palette: state.palette, colourFor: (id) => (id ? state.colours[id] : undefined) };
}
